export default {
    mapLandmarkDeleteLandmarkGroup_title:'Delete Landmark Groups',
    mapLandmarkDeleteLandmarkGroup_move: 'Move to',
    mapLandmarkDeleteLandmarkGroup_deleteAll: 'Delete (All landmarks in those groups are removed)',
    mapLandmarkDeleteLandmarkGroup_success: "Landmark Groups deleted",
    mapLandmarkDeleteLandmarkGroup_question1: 'What do you want to do with landmarks in those landmark groups?',
    mapLandmarkDeleteLandmarkGroup_deleteAction: 'Available Actions',
    mapLandmarkDeleteLandmarkGroup_question2: 'Are you sure you want to delete those landmarks groups?',
    mapLandmarkDeleteLandmarkGroup_warning: 'Delete actions cannot be undone.',
}